import Chip from "@mui/material/Chip";
import { CATEGORIES } from "../../FeedbackDialog.constants";
import type { FeedbackCategoryId } from "../../FeedbackDialog.types";

type FeedbackDialogCategorySelectProps = {
  value: FeedbackCategoryId;
  onChange: (value: FeedbackCategoryId) => void;
};

const FeedbackDialogCategorySelect = ({
  value,
  onChange,
}: FeedbackDialogCategorySelectProps) => (
  <div>
    <span className="mb-2 block text-sm text-text-secondary">Category</span>
    <div
      role="radiogroup"
      aria-label="Feedback category"
      className="flex flex-wrap gap-2"
    >
      {CATEGORIES.map(({ id, label }) => {
        const selected = value === id;
        return (
          <Chip
            key={id}
            label={label}
            role="radio"
            aria-checked={selected}
            color="default"
            variant="outlined"
            onClick={() => onChange(id)}
            className="cursor-pointer"
            sx={selected ? { bgcolor: "action.selected" } : undefined}
          />
        );
      })}
    </div>
  </div>
);

export default FeedbackDialogCategorySelect;
